import diagram_helper from "../../helpers/diagram_helper"
import store from "../../store/store"

const helpers = {
    saveFloodgates(dam_id, gates){
        console.log(dam_id, gates);
        $.each(gates, (gate_id, status)=>{
            store.diagramStore.setDiagramNestedProp(`options.dams[${dam_id}].floodgates.gates[${gate_id}].status`, status)
        })
        diagram_helper.save()
    },
    calculateFlow(equations, dam, floodgate, obj_type){
        let FLOW
        const validDate = (equation) =>{
            let now = new Date()
            let start =_.get(equation.options, 'constraints.period.start')
            if(start && new Date(start).getTime() <= now.getTime()){
                let end =_.get(equation.options, 'constraints.period.end')
                //data inicio valida
                if(!end || new Date(end).getTime() >= now.getTime()){
                    return true
                }
            }
            return false
        }
        const validValue = (equation, value) =>{
            //esse valor esta chegando em centimentros
            value = value / 100 //transformando para metros
            let start = _.get(equation.options, 'constraints.range.start')
            let end = _.get(equation.options, 'constraints.range.end')
            let value_type = _.get(equation.options, 'constraints.range.value_type') || "cm"
            let offset = _.get(equation.options, 'constraints.offset') || "cm"

            if(start >= 0 && end >0){
                if(offset){
                    value = (offset.value_type && offset.value_type === 'cm') ? value + parseFloat(offset.value) / 100 : value + parseFloat(offset.value)
                }
                if(parseFloat(start) <= (value_type == 'cm' ? value * 100 : value) && parseFloat(end) >= (value == 'cm' ? value * 100: value)){
                    return value
                }
            }
            return false
        }

        let station = store.stationStore.getStation(dam.flow_station)
        if(floodgate){
            let flow = 0
            if(station && station.measurements && station.measurements.length > 0){
                let current_value = station.measurements[0].value
                equations.forEach(equation=>{
                    if([3,4,5].includes(equation.equation_type.id) && _.get(equation, "options.custom.id") === obj_type){//apenas de comportas polinomiais
                        if(validDate(equation)){
                            //data e valor validados
                            let value = validValue(equation, current_value)

                            if(value){
                                let format = equation.equation_type.options.format
                                Object.keys(equation.values).forEach(key =>{
                                    format = format.replaceAll(key, equation.values[key])    
                                })
                                format = format.replaceAll('x', value)
                                FLOW = eval(format).toFixed(3)
                            }else{
                                console.log('valor invalido');    
                            }
                            
                            
                        } else {
                            console.log('data invalida');
                        }
                    } else {
                        console.log('Sem equação localizada para comporta');
                    }
                    
                })
            }
        }
        return FLOW
        
    }
}

export default helpers